import { useAppSelector } from "Store/hooks";
import { selectUserList } from "../redux/selectors";
import { columns } from "./columns/columns";
import { Table } from "antd";

const UsersTable = () => {
  const usersList = useAppSelector(selectUserList);
  return (
    <Table
      style={{ padding: "0px" }}
      columns={columns}
      dataSource={usersList}
    />
  );
};
export default UsersTable;
